import type React from "react";
import { type ReactNode, useState } from "react";
import Close from "~/images/close.svg?react";
import styles from "./index.module.scss";

interface TooltipProps {
  children: ReactNode;
}

const PermitDescriptionTooltipGuest: React.FC<TooltipProps> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => {
    setIsVisible(false);
  };

  return (
    <div className={styles["tooltip"]} onClick={showTooltip}>
      {children}
      {isVisible && (
        <div className={styles["tooltip_box"]}>
          <div className={styles["tooltip_box_header"]}>
            <div className={styles["tooltip_box_header_text"]}>権限について</div>
            <div
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation(); // Prevents the click from propagating to the parent
                hideTooltip();
              }}
            >
              <Close />
            </div>
          </div>
          <div className={styles["tooltip_box_text"]}>
            <table className={styles["permissions_table"]}>
              <thead>
                <tr>
                  <th>権限</th>
                  <th>ユーザー招待</th>
                  <th>プロジェクト作成</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ゲスト</td>
                  <td className={styles["cross_symbol"]}>×</td>
                  <td className={styles["cross_symbol"]}>×</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default PermitDescriptionTooltipGuest;
